module.exports = __webpack_public_path__ + "static/media/005-analytics.d372b844.svg";